import { ComponentAPI } from '@philips-internal/oswald-ui-core';
export default class CardAppointmentLocationAPI extends ComponentAPI {
    setOnEnterTeleconsultation(onEnterTeleconsultation) {
        this.setState({ onEnterTeleconsultation: onEnterTeleconsultation });
    }
}
//# sourceMappingURL=card-appointment-detail-location-api.js.map